import { useState } from 'react'
import {
  useMutation as useReactQueryMutation,
  UseMutationOptions as UseMutationOptionsBase
} from '@src/lib/react-query'
import { isEmpty } from '@src/lib/lodash'
import { uuid } from '@src/lib/uuid'

// TODO: 實現 toast
// import { useToast } from '../components'

export interface UseMutationOptions<TData, TParams>
  extends UseMutationOptionsBase<TData, unknown, TParams, any> {
  /** 是否開啟成功通知, 預設為: false */
  showSuccessToast: boolean;
  /** 是否啟用 Logger, 預設為: false  */
  enableLogger?: boolean;
}

export function useMutation<TData, TParams = void>(
  fetchFn: (params: TParams) => Promise<TData>,
  options?: UseMutationOptions<TData, TParams>
) {
  const [mutationFuncName] = useState(() => {
    return !isEmpty(fetchFn?.name) ? fetchFn?.name : uuid()
  });

  const enableLogger = options?.enableLogger ?? false;

  // const showSuccessToast = options?.showSuccessToast || false;
  // const { toast } = useToast();
  const { mutateAsync, data, isPending, isSuccess, isError } = useReactQueryMutation<
    TData,
    unknown,
    TParams
  >({
    mutationFn: async (params: TParams) => {
      let result, error

      try {
        result = await fetchFn(params);

        // if (showSuccessToast) {
        //   toast.success({ title: t('global_rep_succ') });
        // }

        return result
      } catch (error) {
        throw error
      } finally {
        if (enableLogger) {
          console.groupCollapsed(
            `%cuseMutation: %c${mutationFuncName}`,
            'color: #000; font-size:10px; font-weight: 700; font-style: italic;',
            'color: #196c35; font-size:10px; font-weight: 700; font-style: italic;',
          );
          console.log({ params, result, error })
          console.groupEnd()
        }
      }
    },
    ...options
  })

  return { mutate: mutateAsync, data, isPending, isSuccess, isError }
}
